export default {
  setCourierAccountInfo(state, payload) {
    state.courier = payload;
  },
};
